import React from 'react'
import './ouroffices.scss'
import { Sidebar, MainHeading , FindAgent , OurOffices} from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
const OurOfficesMain = () => {
  
  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];
  return (
    <>
      <Container>
        {/* heading  */}
        <MainHeading title="Our offices"/>

        {/* Layout */}
        <Row>
          <Col sm={12} md={6} lg={8} xl={8}>
            <OurOffices/>
          </Col>
          <Col sm={12} md={6} lg={4} xl={4}>
            <Sidebar />
          </Col>
        </Row>
        <FindAgent options={Selectoptions}/>
      </Container>
    </>
  )
}

export default OurOfficesMain